import React from 'react';
import { IActionsCell } from './interfaces';
import { Stack } from '@mui/material';

export const ActionsCell: React.FC<IActionsCell> = ({
  children,
}): JSX.Element => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="end"
      columnGap="10px"
      sx={{
        height: '100%',
        flexWrap: 'nowrap',
        width: 'max-content',
        minWidth: '100%',
      }}
    >
      {children}
    </Stack>
  );
};
